import { render } from "./SalesDeliveriesMonthListPage.vue?vue&type=template&id=e255055a&ts=true"
import script from "./SalesDeliveriesMonthListPage.vue?vue&type=script&lang=ts"
export * from "./SalesDeliveriesMonthListPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__